import React, { Component } from 'react'
import { setError, validateForm } from '../../utils';
import { onChange } from '../../utils';

export default class ChangePasswords extends Component {
    constructor(props) {
        super(props);
        this.state = {
            OLD_PASSWORD: { name: "OLD_PASSWORD", value: '', error: '', isRequired: true },
            NEW_PASSWORD: { name: "NEW_PASSWORD", value: '', error: '', isRequired: true },
            CONFIRM_PASSWORD: { name: "CONFIRM_PASSWORD", value: '', error: '', isRequired: true },
            showPassword: false,
            ConfirmPassword: false,
            confirmPassword:false
        }
    }

    onSubmit = (e) => {
const{CONFIRM_PASSWORD,NEW_PASSWORD,OLD_PASSWORD}=this.state
        e.preventDefault()
        console.log(this.props)

        if (validateForm(this)) {
            // const st = this.state;
			if (NEW_PASSWORD.value != CONFIRM_PASSWORD.value) {
				setError(this, CONFIRM_PASSWORD.name, "New password and Confirm password does not match.")
				return;
			}
            const model = {
                OLD_PASSWORD: OLD_PASSWORD.value,
                NEW_PASSWORD:NEW_PASSWORD.value

            }
         
      
        this.props.onSubmit(model)
        }
        
    }
    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value)
    }
    togglePasswordVisiblity = (e) => {
        this.setState({ showPassword: !this.state.showPassword, ConfirmPassword: !this.state.ConfirmPassword,confirmPassword: !this.state.confirmPassword })
    }

    render() {
        const { OLD_PASSWORD, NEW_PASSWORD, CONFIRM_PASSWORD, showPassword, ConfirmPassword, confirmPassword } = this.state;
        return (
            <React.Fragment>
                
                <section className="form-shared padding-top-150px padding-bottom-100px">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 mx-auto text-center">
                                <div className='forgot-password'>
                                    <img src={'./assets/images/forgot-pasword.png'} />
                                </div>
                            </div>
                            <div className="col-lg-6 mx-auto">
                                <div className="user-action-form">
                                    <div className="tab-content" id="myTabContent">
                                        <div className="tab-pane fade show active" id="signup-nav" role="tabpanel" aria-labelledby="signup-tab">
                                            <div className="billing-form-item mb-0">
                                                <div className="billing-title-wrap border-bottom-0">
                                                    <h3 className="widget-title font-size-28 pb-2">Change Password</h3>
                                                </div>
                                                <div className="billing-content">
                                                    <div className="contact-form-action">
                                                        <form onSubmit={this.onSubmit}>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className="input-box">
                                                                        <label className="label-text">Enter Old Password <span className='text-danger'>*</span></label>
                                                                        <div className="form-group">
                                                                            <i className="la la-user form-icon"></i>
                                                                            <input
                                                                                className={OLD_PASSWORD.error.length > 0 && OLD_PASSWORD.value.length == 0 ? "form-control is-invalid" : "form-control"}
                                                                                type={showPassword ? 'text' : 'password'}
                                                                                name={OLD_PASSWORD.name}
                                                                                value={OLD_PASSWORD.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Enter Old Password" />
                                                                            {OLD_PASSWORD.value.length > 0 && <i onClick={() => { this.setState({ showPassword: !showPassword }) }} className={showPassword ? 'fa fa-fw fa-eye toggle-password field-icon' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px" }}></i>}

                                                                        </div>
                                                                    </div>
                                                                    <div className="input-box">
                                                                        <label className="label-text">Enter New Password <span className='text-danger'>*</span></label>
                                                                        <div className="form-group">
                                                                            <i className="la la-user form-icon"></i>
                                                                            <input
                                                                                className={OLD_PASSWORD.value.length > 0 && NEW_PASSWORD.value == OLD_PASSWORD.value ? "form-control is-invalid" : "form-control"}
                                                                                type={ConfirmPassword ? 'text' : 'password'}
                                                                                name={NEW_PASSWORD.name}
                                                                                value={NEW_PASSWORD.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Enter New Password" />
                                                                            {NEW_PASSWORD.value.length > 0 && <i onClick={() => { this.setState({ ConfirmPassword: !ConfirmPassword }) }} className={ConfirmPassword ? 'fa fa-fw fa-eye toggle-password field-icon mb-4' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px", top: '12px', display: 'block' }}></i>}
                                                                            {OLD_PASSWORD.value.length > 0 && NEW_PASSWORD.value == OLD_PASSWORD.value && <span className='text-danger'> New Password And Old Password Cannot be Same</span>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="input-box">
                                                                        <label className="label-text">Confirm Password <span className='text-danger'>*</span></label>
                                                                        <div className="form-group">
                                                                            <i className="la la-user form-icon"></i>
                                                                            <input
                                                                                className={CONFIRM_PASSWORD.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                                                type={this.state.confirmPassword ? 'text' : 'password'}
                                                                                name={CONFIRM_PASSWORD.name}
                                                                                value={CONFIRM_PASSWORD.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Confirm Password" />
                                                                             {CONFIRM_PASSWORD.value.length > 0 && <i onClick={() => { this.setState({ confirmPassword: !confirmPassword }) }} className={confirmPassword ? 'fa fa-fw fa-eye toggle-password field-icon mb-4' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px", top: '12px', display: 'block' }}></i>}

                                                                                <span className='text-danger'>{CONFIRM_PASSWORD.error.length >0 ? CONFIRM_PASSWORD.error:''}</span>
                                                                               {/* {CONFIRM_PASSWORD.value.length > 0 && CONFIRM_PASSWORD.value != NEW_PASSWORD.value && <span className='text-danger'> NEW PASSWORD and Confirm Pass</span>} */}
                                                                        </div>
                                                                    </div>
                                                                    {/* <Link to={""} className='font-size-12'>Go back to Employer's Login page</Link> */}
                                                                </div>
                                                            </div>
                                                            <div className="btn-box margin-top-30px">
                                                                <button className="theme-btn border-0" type="submit">SUBMIT</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="section-block"></div>
            </React.Fragment>
        )
    }
}
